import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { PatientVo } from './api-client.service';
import { MerakiLookupService } from './meraki/meraki-lookup.service';

export interface HealthIdSearchRequest {
  idNumber: string | null;
  name: string;
  surname: string;
  dateOfBirth: string; // YYYY-MM-DD
  gender: string | undefined; // MALE, FEMALE, etc.
  passportNumber: string | null;
}

export interface HealthIdSearchResponse {
  overview: string;
  medicalHistory: string;
  careProgramme: string;
  cib: string;
  keycare: string;
  status: number;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class HealthIdService {
  constructor(private merakiLookupService: MerakiLookupService) {}

  getHealthIdUrls(patient: PatientVo): Observable<HealthIdSearchResponse> {
    const requestBody: HealthIdSearchRequest = {
      idNumber: patient.PatientDetails.IdentityNo || null,
      name: patient.PatientDetails.FirstName,
      surname: patient.PatientDetails.Surname,
      dateOfBirth: moment(patient.PatientDetails.DateOfBirth).format('YYYY-MM-DD'),
      gender: patient.PatientDetails.Gender?.toUpperCase(),
      passportNumber: patient.PatientDetails.PassportNo || null,
    };

    return this.merakiLookupService.getHealthIdLinkForPatient(requestBody);
  }
}
